import React from 'react';

interface Props {
    title: string;
    lead?: string;
    /** Optional actions under the lead, e.g. download links. */
    children?: React.ReactNode;
}

/** Left-aligned page title for list pages (Projects, Blog, CV). */
export const PageHeader: React.FC<Props> = ({ title, lead, children }) => (
    <header className="page-container pt-14 md:pt-20 pb-2">
        <h1 className="text-[clamp(2.5rem,6vw,4rem)] leading-[1.05] m-0">{title}</h1>
        {lead && <p className="text-muted text-lg mt-4 mb-0 max-w-[38rem]">{lead}</p>}
        {children && <div className="mt-6">{children}</div>}
    </header>
);
